import { useQuery } from "react-query";
import Select from "react-select"

import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getRules } from "../../../../../MyApi/sb/rules";


import icons from "../../../../../Data/icons";

import classes from "./addCompanyFields.module.css";

const AddCompanyRules = ({
  setCompanyId, setDuration, setRuleId, setActive, setValue , active ,setProcessType,duration,value,process_type

  
}) => {
 const companyQuery = useQuery("getCompanies" ,getCompanies)
 const rulesQuery = useQuery("getRules", getRules)


const companies = companyQuery.data?.data || []
const rules = rulesQuery.data?.data || []

const DurationIcon =icons.duration
const ValueIcon=icons.value

  const handleCompanyIdChange = (selectedCompany) => {
    const companyId = selectedCompany ? selectedCompany.id :0
    setCompanyId(companyId);
  };
  const handleRulesIdChange = (selectedRules) => {
    const rulesId = selectedRules ? selectedRules.id :0
    setRuleId(rulesId);
  };
  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };
  const handleValueChange =(e)=>{
    setValue(e.target.value)
  }
  const handleProcessTypeChange =(e)=>{
     setProcessType(e.target.value)
  }
 const handleActiveChange=(e)=>{
 const isChecked = e.target.checked
 setActive(isChecked ? 1 : 0)
 }
  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">ادخل الشركة </label>
          <Select
            type="text"
            placeholder="ادخل  الشركة"
            getOptionLabel={(e)=>e.name}
            getOptionValue={(e)=>e.id}
            options={companies}
            onChange={handleCompanyIdChange}    
          />
        </div>  
        <div className={classes.formCol}>
          <label htmlFor="">ادخل القاعده </label>
          <Select
            type="text"
            placeholder="ادخل  القاعده"
            getOptionLabel={(e)=>e.name}
            getOptionValue={(e)=>e.id}
            options={rules}
            onChange={handleRulesIdChange}    
          />
        </div>  
        <div className={classes.formCol}>
          <label htmlFor=""> المده </label>
          <div className={classes.iconInput}>
             <DurationIcon/>
          </div>
          <input
            type="text"
            placeholder="المده"
            value={duration}
            onChange={handleDurationChange}    
            className={classes.inputCustom} 
          />
        </div>  
        <div className={classes.formCol}>
          <label htmlFor=""> القيمه </label>
          <div className={classes.iconInput}>
             <ValueIcon/>
          </div>
          <input
            type="number"
            placeholder="القيمة"
            value={value}
            onChange={handleValueChange}   
            className={classes.inputCustom} 
          />
        </div>  
        <div className={classes.formCol}>
        <label htmlFor="">نوع العملية</label>
            <select className="form-select" onChange={handleProcessTypeChange} value={process_type}>
              <option>اختار نوع العملية</option>
              <option value="amount">amount</option>
              <option value="days">days</option>
              </select>    
        </div>
        <div className={classes.formCol}>
          <label htmlFor="active"  className={active ? `${classes.active}` : `${classes.disActive}`}>   {active===1 ?" نشط":"غير نشط"} </label>
         
         <label class="switch">
          <input type="checkbox" onChange={handleActiveChange} checked={active}/>
            <span class="slider round"></span>
        </label>  
           </div>
      </div>
    </div>
  );
};

export default AddCompanyRules;
